module.exports = __webpack_public_path__ + "img/mobileHomeChose.16edc02b.svg";